import Konva from 'konva';
import { CrossSectionStore } from './CrossSectionStore';

function drawMeasurement(point: ICrossSectionVertex, x: number, y: number, store: CrossSectionStore, measureTooltipLayer: Konva.Layer, tooltipLayer: Konva.Layer) {
    if (!store.clickedVertex0 || store.clickedVertex1) {
        store.clickedVertex0 = point;
        store.clickedVertex1 = null;

        measureTooltipLayer.add(new Konva.Rect({
            x: store.clickedVertex0.x - (point.markerSize / 2),
            y: store.clickedVertex0.y - (point.markerSize / 2),
            width: point.markerSize,
            height: point.markerSize,
            stroke: 'black',
            strokeWidth: 1,
            listening: false
        }));

        measureTooltipLayer.draw();
    } else {
        store.clickedVertex1 = point;

        let endSize = 4;

        let vertex0 = store.clickedVertex0.x <= store.clickedVertex1.x ? store.clickedVertex0 : store.clickedVertex1;
        let vertex1 = store.clickedVertex0.x <= store.clickedVertex1.x ? store.clickedVertex1 : store.clickedVertex0;

        let dx = vertex1.point.x - vertex0.point.x;
        let dy = vertex1.point.y - vertex0.point.y;

        let x0 = vertex0.x;
        let y0 = vertex0.y;
        let x1 = vertex1.x;
        let y1 = vertex1.y;
        let right = Math.max(x0, x1);
        let bottom = Math.max(y0, y1);
        tooltipLayer.destroyChildren();

        let textX = new Konva.Text({
            x: x0 + ((x1 - x0) / 2),
            y: bottom + 15,
            text: dx.toFixed(2) + "m",
            fontSize: 13,
            fontFamily: 'Calibri',
            fill: 'black',
            listening: false
        });
        textX.offsetX(textX.width() / 2);

        let textY = new Konva.Text({
            x: right + 15,
            y: y0 + ((y1 - y0) / 2),
            text: dy.toFixed(2) + "m",
            fontSize: 13,
            fontFamily: 'Calibri',
            fill: 'black',
            listening: false
        });
        textY.offsetY(textY.height() / 2);
        let slope = Math.abs(dy / dx);
        let slopeInverted = Math.abs(dx / dy) < 10 ? Math.abs(dx / dy).toFixed(1) : Math.abs(Math.round(dx / dy));
        let slopeText = "(1:" + slopeInverted + " = " + slope.toFixed(3) + ")";
        if (slope > 1) {
            slope = Math.abs(dx / dy);
            slopeInverted = Math.abs(dy / dx) < 10 ? Math.abs(dy / dx).toFixed(1) : Math.abs(Math.round(dy / dx));
            slopeText = "(" + slopeInverted + ":1 = " + slope.toFixed(3) + ")";
        }

        let textDistance = new Konva.Text({
            x: (x0 + x1) / 2 - 30,
            y: (y0 + y1) / 2 - 10,
            text: (Math.sqrt(dy * dy + dx * dx)).toFixed(2) + "m  " + slopeText,
            fontSize: 13,
            rotation: 360 - Math.atan(dy / dx) * 180 / Math.PI,
            fontFamily: 'Calibri',
            fill: 'black',
            listening: false
        });
        textDistance.offsetY(textY.height() / 2);

        let boxw = (x1 - x0) + textY.width() + 50;
        let boxh = (y1 - y0) + textX.height() + 30;
        let box = new Konva.Rect({
            x: x0 - 10,
            y: y0 - 10,
            width: boxw,
            height: boxh,
            opacity: 0.8,
            fill: 'white',
            listening: false
        });
        measureTooltipLayer.add(box);

        // line between points
        measureTooltipLayer.add(new Konva.Line({
            points: [x0, y0, x1, y1],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));

        // width marker line
        measureTooltipLayer.add(new Konva.Line({
            points: [x0, bottom + 10, x1, bottom + 10],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));
        measureTooltipLayer.add(new Konva.Line({
            points: [x0 - endSize, bottom + 10 + endSize, x0 + endSize, bottom + 10 - endSize],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));
        measureTooltipLayer.add(new Konva.Line({
            points: [x1 - endSize, bottom + 10 + endSize, x1 + endSize, bottom + 10 - endSize],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));

        // height marker line
        measureTooltipLayer.add(new Konva.Line({
            points: [right + 10, y0, right + 10, y1],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));
        measureTooltipLayer.add(new Konva.Line({
            points: [right + 10 - endSize, y0 + endSize, right + 10 + endSize, y0 - endSize],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));
        measureTooltipLayer.add(new Konva.Line({
            points: [right + 10 - endSize, y1 + endSize, right + 10 + endSize, y1 - endSize],
            stroke: 'black',
            strokeWidth: 1,
            lineCap: 'round',
            lineJoin: 'round',
            listening: false
        }));

        measureTooltipLayer.add(textX);
        measureTooltipLayer.add(textY);
        measureTooltipLayer.add(textDistance);

        /*
        let textSlope = new Konva.Text({
            x: right + 15,
            y: bottom + 15,
            text: slope.toFixed(2), // + " [1:" + slopeInverted + "]",
            fontSize: 12,
            fontFamily: 'Calibri',
            fill: 'black',
            listening: false
        });
        textSlope.offsetY(textSlope.height() / 2);
        measureTooltipLayer.add(textSlope);
        */

        measureTooltipLayer.draw();
    }
}

export const CrossSectionPointsMeasurement = {
    drawMeasurement
}
